import React, { useEffect, useState } from 'react';
import Card from '../Card';

const Widget = ({ icon, title, subtitle, amount }) => {
  const [number, setNumber] = useState(0);

  useEffect(() => {
  if (typeof subtitle === "number") {
    animateNumber(subtitle);
  } else if (typeof subtitle === "string") {
    // Remove commas, currency symbols, % signs, etc.
    const numericValue = parseInt(subtitle.replace(/[^0-9.-]/g, ""), 10);

    if (!isNaN(numericValue)) {
      animateNumber(numericValue);
    } else {
      // Fallback: just show the string as is
      setNumber(subtitle);
    }
  }
}, [subtitle]);

const animateNumber = (end) => {
  let start = 0;
  const duration = 2000;
  const incrementTime = 10;
  const step = (end - start) / (duration / incrementTime);

  const timer = setInterval(() => {
    start += step;
    if (start >= end) {
      setNumber(end);
      clearInterval(timer);
    } else {
      setNumber(Math.ceil(start));
    }
  }, incrementTime);
};


  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px]">
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className="rounded-full bg-[#f8e6ef] p-3 dark:bg-navy-700">
          <span className="flex items-center text-[#c51369] dark:text-white">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-4 mt-2 flex w-auto flex-col justify-center">
        <p className="font-dm text-sm font-medium tracking-wide text-gray-700">
          {title}
        </p>
        <h4 className="text-xl font-bold tracking-wider text-navy-700 dark:text-white">
          {typeof number === "number" ? number.toLocaleString() : number}
        </h4>

        {amount !== undefined && (
          <div className="my-1 flex">
            <p className="text-md mr-2 tracking-wide text-gray-500">Amount</p>
            <span className="mt-1 text-sm font-semibold tracking-wide text-[#c51369] dark:text-pink-400">
              ₹ {isNaN(amount) ? 0 : Number(amount).toLocaleString()}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Widget;
